<script setup lang="ts">
import {
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  VisuallyHidden,
} from 'reka-ui'
import { Button } from '@/components/ui/button'

const modelValue = defineModel<boolean>({ required: true })

defineProps<{
  updateAvailable?: boolean
}>()

function reloadPage() {
  window.location.reload()
}
</script>

<template>
  <DialogRoot v-slot="{ close }" v-model:open="modelValue">
    <DialogPortal>
      <DialogOverlay
        class="fixed inset-0 z-54 bg-black/20 backdrop-blur-xl data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 duration-250 ease-out"
      />
      <DialogContent
        class="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-50 data-[state=open]:zoom-in-50 fixed z-55 top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] duration-250"
        @interact-outside="(e) => e.preventDefault()"
      >
        <VisuallyHidden>
          <DialogTitle>Privacy Screen</DialogTitle>
          <DialogDescription>
            This dialog prevents sensitive information from being visible to others.
          </DialogDescription>
        </VisuallyHidden>
        <div class="flex flex-col items-center justify-center space-y-6">
          <Button class="px-8 py-4 h-auto" @click="close()">
            <div class="space-y-1">
              <div class="text-4xl lowercase">
                <span class="font-black">Clarity</span><span class="text-boss font-base">Boss</span>
              </div>
              <p class="text-lg font-semibold">Privacy Screen - Click to Dismiss</p>
              <p class="text-xs">Automatic privacy mode can be toggled in the top bar menu.</p>
            </div>
          </Button>
          <Button v-if="updateAvailable" class="text-md px-8 py-4 h-auto" @click="reloadPage()">
            <div>
              <div class="font-semibold">A new version of ClarityBoss is available!</div>
              <div>Click here to update.</div>
            </div>
          </Button>
        </div>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
